var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { runInAction } from 'mobx';
import { Observer } from 'mobx-react-lite';
import React, { useEffect, useRef } from 'react';
import { ContextColor } from '../../constants/color.enum';
import { useContextColorStyle } from '../../hooks/useContextColor.hook';
import joinClassName from '../../utils/className.utils';
import { checkIfShouldInvertStyle } from '../../utils/colors.utils';
import { useProps, useStore } from '../../utils/mobx.utils';
import './ShadedBlock.scss';
var ShadedBlock = function (props) {
    var ref = useRef(null);
    var p = useProps(props);
    var colorStyle = useContextColorStyle(ContextColor.Primary, p.color);
    var s = useStore(function () { return ({
        shouldInvertStyle: false,
        get interactable() {
            return (p.onClick);
        }
    }); });
    useEffect(function () {
        runInAction(function () {
            s.shouldInvertStyle = checkIfShouldInvertStyle(ref);
        });
    });
    var style = __assign({}, colorStyle);
    return React.createElement(Observer, { children: function () { return (React.createElement("div", { className: joinClassName('ShadedBlock', p.className, p.spaceChildren && 'spaceChildren', s.shouldInvertStyle && 'inverted', p.rounded && 'rounded', s.interactable && 'interactable', p.colorIntensity === 'strong' && 'intenseColor'), style: style, ref: ref, "data-cy": p.dataCy, onClick: p.onClick },
            React.createElement("div", { className: "ShadedBlockInner", style: { borderWidth: p.borderWidth } }, props.children))); } });
};
export default ShadedBlock;
